import React from 'react';
import Text from 'components/Text/Text';
import { Link } from 'react-router-dom';
import { IItemForGetShortInfo } from 'types';
import style from './SubcategoryList.module.scss';

interface IProps {
	subcategories: IItemForGetShortInfo[];
}

export const SubcategoryList: React.FC<IProps> = React.memo(({ subcategories }) => {
	return (
		<div data-test="SubcategoryList">
			<Text translationNameSpace="form" translationKey="subcategoryLabel" theme="neutralLight" size="xs" />
			<div className={style.list}>
				{subcategories.length ? (
					subcategories.map((el) => {
						return (
							<div key={el.id} className={style.item}>
								<div className={style.dot} />
								<Link
									className={style.link}
									rel="noopener noreferrer"
									to={`/menu-v2/subcategory/edit?subcategoryID=${el.id}`}
									target={`blank_${Date.now()}`}>
									<Text translationKey={el.name} asFragment={true} />
								</Link>
							</div>
						);
					})
				) : (
					<Text translationNameSpace="form" translationKey="-" />
				)}
			</div>
		</div>
	);
});
